<input type="text" class="view-select-replace" [value]="inputBoxValue" readonly/>